@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t">
  @if (!isLoading) {
    <div class="widget-predictive__container">
      @if (dataSourceNotFound) {
        <div class="text-center">
          <h1>{{ dataSourceNotFoundText }}</h1>
        </div>
      }
      @if (hasInvalidComparison) {
        <div class="text-center">
          <h1>{{ t('widgets.has-invalid-comparison') }}</h1>
        </div>
      }
      @if (!dataSourceNotFound && !hasInvalidComparison) {
        @switch (payload.view) {
          @case ('crosstab') {
            <ng-container [ngTemplateOutlet]="crosstabView"></ng-container>
          }
          @default {
            <ng-container [ngTemplateOutlet]="predictorView"></ng-container>
          }
        }
      }
    </div>
  }
</ng-container>

<ng-template #crosstabView>
  <div class="widget-predictive__crosstab-view">
    <app-predictive-crosstab
      [breakdowns]="breakdowns"
      [showChange]="canCalculateTrend"
      [dependentColumn]="driverCalculation.request.dependentColumn"
      [changeColumnLabel]="comparison?.filters[0].label"
      [predictiveOptions]="payload"
    ></app-predictive-crosstab>

    <ng-container *ngTemplateOutlet="chart"></ng-container>
  </div>
</ng-template>

<ng-template #predictorView>
  <div
    class="widget-predictive__predictor-view"
    [class.widget-predictive__predictor-view--panel-open]="isPanelOpen"
  >
    <app-predictive-breakdown-widgetette
      [breakdowns]="breakdowns"
      [focusedBreakdown]="selectedBreakdown"
      [predictiveOptions]="payload"
      [isReadOnly]="isReadOnly"
      [isDashboardLocked]="dashboard.locked"
      [comparison]="comparison"
      (selectBreakdown)="onSelectBreakdown($event)"
      (hideBreakdown)="onHideBreakdown($event)"
      (resetBreakdownSimulation)="onResetBreakdownSimulation($event)"
      (metricSettingsChange)="onMetricSettingsChange($event)"
    >
    </app-predictive-breakdown-widgetette>

    <app-predictive-driver-widgetette
      [breakdown]="selectedBreakdown"
      [predictiveOptions]="payload"
      [isReadOnly]="isReadOnly"
      [isDashboardLocked]="dashboard.locked"
      [comparison]="comparison"
      (simulateDriver)="onSimulate($event)"
      (resetDriver)="onResetDriverSimulation($event)"
      (smartSummaryDriver)="onOpenSmartSummaryDialog($event)"
      (hoverDriver)="onHoverDriver($event)"
    >
    </app-predictive-driver-widgetette>

    <ng-container *ngTemplateOutlet="chart"></ng-container>
  </div>
</ng-template>

<ng-template #chart>
  <app-predictive-chart-widgetette
    [breakdown]="selectedBreakdown"
    [predictiveOptions]="payload"
    [isReadOnly]="isReadOnly"
    [isDashboardLocked]="dashboard.locked"
    [hoveredDriver]="hoveredDriver"
    (smartSummary)="onOpenSmartSummaryDialog($event)"
  ></app-predictive-chart-widgetette>
</ng-template>

@if (showSmartSummaryModal) {
  <app-lex-xi-modal
    [isVisible]="showSmartSummaryModal"
    [canBackdropClose]="false"
    maxWidth="80vw"
    (close)="onSmartSummaryClosed($event)"
  >
    <ng-template appXIModalContent>
      @if (showSmartSummaryModal) {
        <app-interactive-smart-summary
          [options]="interactiveSmartSummaryOptions"
          (modalClosed)="onSmartSummaryClosed($event)"
          (addComment)="onAddSmartSummaryComment($event)"
          (addNotes)="onAddSmartSummaryNotes($event)"
        ></app-interactive-smart-summary>
      }
    </ng-template>
  </app-lex-xi-modal>
}
